import { HosReportState } from '../types';

export const reportsState: HosReportState = {
  drivers: [],
  reports: [],
  hiddenReports: [],
  isRequestPending: false,
};
